export default __webpack_public_path__ + "static/media/oscer-pres-inguinoscrotal-pain.e4e51163.svg";